import { deleteRequest, get, post } from "@/lib/http";
import { toast } from "sonner";
import { proxy, snapshot, useSnapshot } from "valtio";

const subscriptionProxy = proxy({
  subscriptionLoading: false,
  subscriptionExists: false,

  async subscribe(
    plan_code: string | undefined,
    external_customer_id: string | unknown
  ) {
    subscriptionProxy.subscriptionLoading = true;
    if (!plan_code) {
      toast.error("Plan code is empty");
      subscriptionProxy.subscriptionLoading = false;
      return;
    }

    try {
      await post("/api/subscription", {
        plan_code: plan_code,
        external_customer_id: external_customer_id
      });

      subscriptionProxy.subscriptionLoading = false;
      subscriptionProxy.subscriptionExists = true;
      toast.success("Successfully subscribed");
    } catch (error: unknown) {
      toast.error(`Subscription failed to create : ${error}`);
      subscriptionProxy.subscriptionLoading = false;
    }
  },

  async exists(
    plan_code: string | undefined,
    external_customer_id: string | unknown
  ) {
    if (!plan_code) throw Error("Empty parameters");
    const exists = await get<boolean>(
      `/api/subscription/exists?plan_code=${plan_code}&external_customer_id=${external_customer_id}`
    );
    subscriptionProxy.subscriptionExists = exists;
    return exists;
  },

  async unsubscribe(
    plan_code: string | undefined,
    external_customer_id: string | unknown
  ) {
    subscriptionProxy.subscriptionLoading = true;
    if (!plan_code) {
      toast.warning("Parameters must not be empty");
      throw Error("Parameters are  empty");
    }
    try {
      await deleteRequest(
        `/api/subscription?plan_code=${plan_code}&external_customer_id=${external_customer_id}`
      );
      subscriptionProxy.subscriptionExists = false;
      toast.success("Unsubscribed from plan");
    } catch (error: unknown) {
      toast.error(`Failed to unsubscribe !`);
      console.error(error);
    } finally {
      subscriptionProxy.subscriptionLoading = false;
    }
  }
});

export const getSubscriptionProxy = () => subscriptionProxy;
export const getSubscriptionSnapshot = () => snapshot(subscriptionProxy);

export const useSubscriptionSnapshot = (
  options?: Parameters<typeof useSnapshot>[1]
) => useSnapshot(subscriptionProxy, options);

export const useSubscriptionProxy = () => subscriptionProxy;
export const useSubscriptionStore = (
  options?: Parameters<typeof useSnapshot>[1]
) => {
  return {
    subscriptionSnapshot: useSnapshot(subscriptionProxy, options),
    subscriptionProxy: subscriptionProxy
  };
};
